import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Spin: ComponentStyleConfig = {
  parts: ['Container', 'Indicator', 'SpinWrapper', 'Spinner', 'BlurContainer'],
  baseStyle: (props) => ({
    Container: {
      h: '100%',
      w: '100%',
    },
    Indicator: {
      position: 'absolute',
      ...(props.spinning
        ? {
            w: '100%',
            h: '100%',
          }
        : {}),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      left: 0,
    },
    SpinWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    Spinner: {
      thickness: '4px',
      color: 'raspberry.500',
      my: 4,
    },
    BlurContainer: {
      w: '100%',
      ...(props.spinning
        ? {
            opacity: 0.5,
            clear: 'both',
            userSelect: 'none',
            pointerEvents: 'none',
          }
        : {}),
    },
  }),
};

export default Spin;
